/**
 * Detail list — a compact two-column label / value grid (a `<dl>`) for the
 * structured facts on a card (the shares page's sale + grant cards, the income
 * page's employment + pay event cards), instead
 * of run-on " · "-joined meta lines.
 *
 *   card content: createDetailList([
 *     { label: 'Sold on', value: '19 Aug 2026' },
 *     { label: 'After fees', value: '$23,795.00', key: 'proceeds' },
 *   ]);
 *
 * Items with an empty value (null / undefined / '') are skipped, so callers
 * can list optional facts unconditionally. A value may be a string or a Node.
 * Styles in detail-list.css (`.detail-list`).
 */
import './detail-list.css';

/**
 * @param {Array<{ label: string, value: string|Node|null|undefined, key?: string }>} items
 * @param {{ className?: string }} [opts]
 * @returns {HTMLDListElement}
 */
export function createDetailList(items, { className } = {}) {
  const dl = document.createElement('dl');
  dl.className = className ? `detail-list ${className}` : 'detail-list';
  for (const { label, value, key } of items) {
    if (value === null || value === undefined || value === '') continue;
    const dt = document.createElement('dt');
    dt.textContent = label;
    const dd = document.createElement('dd');
    dd.append(value);
    if (key) {
      dt.dataset.key = key;
      dd.dataset.key = key;
    }
    dl.append(dt, dd);
  }
  return dl;
}
